import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'formatString'
})
export class FormatStringPipe implements PipeTransform {

    transform(data: any, args?: any): any {
        if(typeof data === "object") {
            let arr = Object.entries(data);
            data = arr.map(item => item.join(" = "));
            return (data.join('%, ') + '%').replace(/otimo/gi, "ótimo");
        } else {
            return data;
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/format-string.pipe.ts